export const ODP_HOME_TAB_ODP = 0;
export const ODP_HOME_TAB_STAPLING = 0;
export const ODP_HOME_TAB_PROCESSES = 2;
export const ODP_HOME_TAB_DOCUMENTS = 3;
export const ODP_HOME_TAB_EXPORT = 4;
export const ODP_HOME_TAB_STAPLING_VARS = 5;
export const ODP_HOME_TAB_STAPLING_CHECKS = 6;
export const ODP_HOME_TAB_MACHINE_EVENTS = 7;